import { faQuestion, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import splash from '../../media/classroomSplash.jpg'
import QuoteIcon from '../../media/icon-science.svg?react'
import oftmcssLogo from '../../media/maricopa-footer-logo.svg'
import { clearSession, hasInvalidSession } from '../../session'
import { IStoreState } from '../../store'
import { Brand, Content, Form, Modal, Templates } from 'ui'
import { LoginForm } from '../../Forms'
import { randomTestimonial } from './testimonials'

/**
 * A basic login form to sign into the application (applies to all user types).
 */
const LoginViewComponent: React.FC = () => {
  const testimonial = randomTestimonial()
  const dispatch = useDispatch<any>()
  const handleDismiss = () => {
    dispatch(clearSession({ invalidSession: false }))
    return
  }
  const sessionLost = useSelector((state: IStoreState) =>
    hasInvalidSession(state.session)
  )

  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Login to Your Account - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading className="mt-3">Log In</Content.Heading>
        <LoginForm />
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faQuestion} />
            </Content.ListIcon>
            <Link to="/login/forgot">Forgot your password?</Link>
          </Content.ListItem>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faUserPlus} />
            </Content.ListIcon>
            <Link to="/">Sign Up Today.</Link>
          </Content.ListItem>
        </Content.List>
        {sessionLost ? (
          <Modal.View onDismiss={handleDismiss}>
            <div className="flex-col flex p-4 pt-0">
              <Content.HeadingSmall>
                Your Session Has Expired
              </Content.HeadingSmall>
              <Content.Body>
                Whoops! It looks like we couldn't keep you signed in. This may
                be becuase you signed in on another device or that it's just
                been too long since you've last logged in. Don't worry - it's
                easy to solve. You'll just need to sign in again to access the
                system.
              </Content.Body>
              <Form.ButtonGroup direction="row">
                <Form.Button onClick={handleDismiss}>
                  <span>Okay, I Will Login</span>
                </Form.Button>
              </Form.ButtonGroup>
            </div>
          </Modal.View>
        ) : null}
      </Content.Region>
    </Templates.SplashImageView>
  )
}

export const LoginView = LoginViewComponent
